// Deep Link Version support: >= 2.6.55 AND < 2.7 OR >= 2.9

export function determineSupportsDeepLinksV1(appVersion: string): boolean {
  if (!appVersion) {
    return true;
  }
  const versionParts = [0, 0, 0];
  String(appVersion)
    .split('.')
    .forEach((part, i) => {
      versionParts[i] = Number(part) || 0;
    });
  const [major, minor, patch] = versionParts;

  if (major >= 2) {
    if (major > 2) {
      //major versions > 2 should support deep links
      return true;
    }
    if (minor >= 6 && minor < 7 && patch >= 55) {
      // versions >= 2.6.55 and under 2.7 support deep links
      return true;
    }
    if (minor >= 9) {
      // versions >= 2.9 should support deep links
      return true;
    }
  }
  // everything else does not support deep links
  return false;
}
